import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import './index.css';
import { TooltipProps } from 'antd/es/tooltip';

const TruncatedText: React.FC<{
  text?: string;
  lineClamp?: number;
  textClassName?: string;
  overlayInnerStyle?: React.CSSProperties;
  tooltipProps?: Partial<TooltipProps>;
}> = ({
  text,
  lineClamp = 2,
  textClassName = '',
  overlayInnerStyle = {},
  tooltipProps = {},
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      const element = textRef.current;
      if (element) {
        // 判断文本是否被截断
        setIsTruncated(element.scrollHeight > element.clientHeight);
      }
    });
  }, [text, lineClamp]);

  const textContent = (
    <div
      ref={textRef}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lineClamp, // 根据传入的行数自定义显示行数
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
        color: 'inherit',
        fontSize: 'inherit',
      }}
      className={textClassName}
    >
      {text}
    </div>
  );

  return isTruncated ? (
    <Tooltip
      title={text}
      overlayInnerStyle={overlayInnerStyle}
      overlayClassName="tooltip-scroll"
      {...tooltipProps}
    >
      {textContent}
    </Tooltip>
  ) : (
    textContent
  );
};

export default TruncatedText;
